import React from 'react';
import PropTypes from 'prop-types';
import { getTag } from '../../config/tags';

const PolarityField = ({ record = {}, source }) => {
  const tag = getTag(record[source]);
  return <div>{record[source] && <span className={`tag-field-${tag.ref}`}>{tag.name}</span>}</div>;
};

PolarityField.propTypes = {
  record: PropTypes.object,
  source: PropTypes.string.isRequired,
};

export default PolarityField;



// WEBPACK FOOTER //
// ./src/resources/ui/PolarityField.js